import React, { FC, ReactNode } from 'react'
import Modal from 'react-bootstrap/esm/Modal'
import './ModalWrapper.scss'
type AllowedSize = 'lg' | 'sm' | 'xl' | undefined

interface propsType {
  showModal: boolean
  closeModal: () => void
  title: ReactNode
  size?: AllowedSize
  children: ReactNode
  className?: string
}
const ModalWrapper: FC<propsType> = ({
  showModal,
  closeModal,
  title,
  size,
  className,
  children,
}) => {
  return (
    <Modal
      show={showModal}
      size={size}
      onHide={closeModal}
      dialogClassName={`modalWrapper ${className ?? ''}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}

export default ModalWrapper
